"use client";
import React from 'react'
import Image from 'next/image'
import {
  A11y,
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
  Parallax,
} from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import Content from '../../_utilities/data/sliders/hero-slideshow.json'

interface Slide {
  image: string
}

interface Item {
  title: string
  link: string
  label: string
  text: string
}

const Home1BannerSlider: React.FC = () => {
  return (
    <div className="mil-banner mil-top-space-0">
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay, EffectFade, Parallax]}
        slidesPerView={1}
        spaceBetween={30}
        speed={800}
        autoplay={{ delay: 5000 }}
        effect="fade"
        parallax={true}
        loop={true}
        pagination={{ el: '.mil-banners-pagination', type: 'bullets', clickable: true }}
        navigation={{ prevEl: '.mil-banner-prev', nextEl: '.mil-banner-next' }}
        className="swiper-container mil-banner-slideshow"
      >
        {Content.slides.map((slide: Slide, key: number) => (
          <SwiperSlide className="swiper-slide" key={key}>
            <Image
              src={slide.image}
              className="mil-background-image "
              style={{ objectPosition: 'center', width: '100%', height: '100%' }}
              data-swiper-parallax={-100}
              data-swiper-parallax-scale="1.1"
              alt="image"
              width={1000}
              height={1000}
              priority={true}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="mil-overlay" />
      <div className="mil-banner-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-md-12">
              <span className="mil-suptitle mil-mb-60"></span>
              <h1 className="mil-mb-60">
                <span className="mil-uppercase mil-light mil-h1">{Content.title.first}</span><br></br>
                <span className="mil-font-3 mil-accent mil-h1">{Content.title.second}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home1BannerSlider
